module.exports = __webpack_public_path__ + "img/close-circle.0b1bc6dd.svg";